import { inject, Pipe, PipeTransform } from '@angular/core';

import { COLOR_OPACITY_AREA, COLOR_OPACITY_COMPETENCE, COLOR_OPACITY_SUBAREA } from '../constants/colors-opacity';
import { ColorService } from '../services/color/color.service';

export type TagType = 'area' | 'subarea' | 'competence';

@Pipe({
  name: 'tagColorPipe',
  standalone: false,
})
export class TagColorsPipe implements PipeTransform {
  private readonly colorService = inject(ColorService);

  transform(value: string, tagType: TagType): string {
    switch (tagType) {
      case 'area':
        return this.colorService.mixWithWhite(value, COLOR_OPACITY_AREA);
      case 'subarea':
        return this.colorService.mixWithWhite(value, COLOR_OPACITY_SUBAREA);
      case 'competence':
        return this.colorService.mixWithWhite(value, COLOR_OPACITY_COMPETENCE);
      default:
        return '#000000';
    }
  }
}
